import React from "react"
import clsx from "clsx"
import Switch from "../../Switch/Switch";

export default class PropertyDetailsBuilderTwilio extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
    this.twilio_profile_verify = this.twilio_profile_verify.bind(this);
  };

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'text_messaging',
      'tab-pane': true,
    });
    return (
      <div className={tabClasses}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('twilio_account_sid')}</label>
              <input type="text" className="form-control" name="twilio_account_sid" value={this.props.twilio_account_sid || ''} onChange={this.props.onChange} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('twilio_auth_token')}</label>
              <input type="text" className="form-control" name="twilio_auth_token" value={this.props.twilio_auth_token || ''} onChange={this.props.onChange} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t('twilio_messaging_service_sid')}</label>
              <input type="text" className="form-control" name="twilio_messaging_service_sid" value={this.props.twilio_messaging_service_sid || ''} onChange={this.props.onChange} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("twilio_number")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("twilio_phone_number_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                className="form-control"
                name="twilio_number"
                onChange={this.props.onChange}
                value={this.props.twilio_number || ""}
              />
            </div>
          </div>
          {/* {this.renderFieldErrors('twilio_number')} */}
          <div className="col-md-4">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {I18n.t("enable_messaging")}
              </label>
              <br />
              <Switch
                onText="yes"
                switchId="enable_messaging"
                offText="no"
                name="enable_messaging"
                onChange={this.props.onChangeEnableMessaging}
                value={this.props.enable_messaging}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {I18n.t('verify_business_info')}
              </label>
              <br />
              <button className="btn btn-primary" onClick={this.twilio_profile_verify} >{I18n.t('verify')}</button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {I18n.t("enable_messaging_terms")}
              </label>
              <br />
              <Switch
                onText="yes"
                switchId="enable_messaging_terms"
                offText="no"
                name="enable_messaging_terms"
                onChange={this.props.onChangeEnableMessagingTerms}
                value={this.props.enable_messaging_terms}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  twilio_profile_verify() {
    var self = this;
    self.setState({ loading: true })
    $.ajax({
      type: "POST",
      url: self.props.twilio_profile_verify_path,
      data: {
        id: self.props.id,
      },
    }).done((data) => {
      self.setState({ loading: false })
      if (data.errors && Object.keys(data.errors).length) {
        self.setState({
          errors: data.errors,
        });
      } else {
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('twilio_profile_saved_successfully'));
        }
      }
    }).catch((data) => {
      if (data && data.responseJSON) {
        self.setState({ errors: data.responseJSON, loading: false })
        $('.modal-body').scrollTop(0)
      }
    })
  }

}
